import {
  Input,
  OnInit,
  Output,
  Component,
  ElementRef,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';

// Pipes
import { TranslatePipe } from '../../pipes/translate/translate.pipe';

@Component({
  selector: 'dropdown-checkbox',
  templateUrl: './dropdown-checkbox.component.html',
  styleUrls: ['./dropdown-checkbox.component.scss'],
  host: {'(document:click)': 'onClick($event)'},
})
export class DropdownCheckboxComponent implements OnInit, OnChanges {

  // Inputs variables
  @Input() items: any[];
  @Input() selected: any[] | null = [];
  @Input() disabled: boolean;
  @Input() placeholder: string = 'Select element';
  @Input() valuesSelected: number = 0;

  // Output variables
  @Output() onItemSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDropdownClose: EventEmitter<boolean> = new EventEmitter<boolean>();

  // Suscriptions
  private selectedWatch$: any;

  // Selected item
  public itemSelected: string = '';
  public itemsSelected: any[] = [];


  // Dropdown open status
  public dropdownOpened: boolean = false;

  // Constructor
  constructor(
    private _eref: ElementRef,
    private translatePipe: TranslatePipe
  ) {}

  // On component init
  ngOnInit() {
    this.itemSelected = this.translatePipe.transform(this.placeholder);
    if (this.selected) this.findSelected();
  }

  // On component do check
  ngOnChanges(changes: SimpleChanges) {
    if (changes.selected && changes.selected.previousValue && changes.selected.currentValue && changes.selected.currentValue !== changes.selected.previousValue) {
      this.itemsSelected = [];
      this.findSelected(changes.selected.currentValue);
    }
  }

  // Fill selected
  private findSelected(selected: any = null): void {
    if (selected) this.selected = selected;
    this.selected.forEach((item, index) => {
      for (let i = 0; i < this.items.length; i++) {
        if (parseInt(this.items[i].key, 10) === parseInt(item, 10)) {
          this.itemsSelected.push(this.items.find(findElement => findElement.key === item));
          if (index === 0) {
            this.itemSelected = `${this.items[i].text}`;
          } else {
            this.itemSelected += `, ${this.items[i].text}`;
          }
          break;
        }
      }
    });
  }

  // On element click
  public onClick(event): void {
    if (!this._eref.nativeElement.children[0].children[0].contains(event.target) && this.dropdownOpened) {
      this.dropdownOpened = false;
      this.onDropdownClose.emit(true);
    }
  }

  // Selecting an item
  public itemSelect(item): void {

    const index1 = this.itemsSelected.findIndex(n => parseInt(n.key, 10) === parseInt(item.key, 10));

    // If the item does not exist
    if (index1 === -1) this.itemsSelected.push(item);
    // If the item exists, then remove
    else this.itemsSelected.splice(index1, 1);

    this.itemSelected = '';
    // writing items selected
    if (this.itemsSelected.length > 0) {
      if (this.itemsSelected.length === 1) {
        this.itemSelected = this.translatePipe.transform(this.itemsSelected[0].text);
      }
      else {
        for (let i = 0; i < this.itemsSelected.length; i++) {
          if (i === 0) this.itemSelected = this.translatePipe.transform(this.itemsSelected[0].text);
          else this.itemSelected = this.itemSelected + ', ' + this.translatePipe.transform(this.itemsSelected[i].text);
        }
      }
    }
    this.onItemSelect.emit(item);
  }

  // Check notification selection status
  public isNotificationSelected(item: any): boolean {
    return this.itemsSelected.findIndex(n => n.key === item.key) >= 0;
  }

  public onClickDropdown(): void {
    if (!this.disabled) {
      this.dropdownOpened = !this.dropdownOpened;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown-checkbox/dropdown-checkbox.component.ts